import { Textarea } from "@maxhub/max-ui"
import { useState } from "react"

export const TextAreaExample = {
    title: 'Textarea',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'mode',
            label: 'mode',
            type: 'enum',
            tsType: ['"primary"', '"secondary"'],
            default: "secondary",
            options: ['primary', 'secondary']
        },
        {
            name: 'disabled',
            label: 'disabled',
            type: 'boolean',
            tsType: 'boolean',
            default: false
        },
        {
            name: 'placeholder',
            label: 'placeholder',
            type: 'text',
            tsType: 'string',
            default: "Placeholder",
        },
        {
            name: 'innerClassNames',
            label: 'innerClassNames',
            type: 'static',
            tsType: 'InnerClassNamesProp<"textarea">',
            value: '-',
        },
    ],


    Preview({ props }){
        const [value, setValue] = useState()

        const textareaProps = {
            mode: props.mode,
            disabled: props.disabled,
            placeholder: props.placeholder || undefined,
            value,
            onChange: (event) => {
                setValue(event.target.value)
            },
        }
        return (<Textarea {...textareaProps}/>)
    },

    getCode(){
        return `<Textarea
                  defaultValue=""
                  mode="secondary"
                  placeholder="Placeholder"/>`
    }

}